import React from 'react'
import Form from './form'

export default function ProgramToolAdd (props) {
  return <div>
    <Form data={{ type: 1, active: false }} {...props} />
  </div>
}